module.exports = __webpack_public_path__ + "35c4f322b3dad1ba975f3c2e40148ac5.MP3";